function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9053 0.115684L11.0528 12.301L2.20033 0.115684H0V21.0287H5.47525V12.8152L11.04 20.6816H11.0784L16.6304 12.8152V21.0287H22.1057V0.115684H19.9053Z",
  fill: "#330B86"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.5232 21.0287H35.9601V12.0825L42.3308 0.308489H36.1136L33.2481 6.31118L30.3697 0.308489H24.1653L30.5232 12.0825V21.0287Z",
  fill: "#330B86"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.8251 21.3115C54.9571 21.3115 58.6158 18.8564 58.6158 14.9103C58.6158 11.8511 56.4795 9.87166 53.2557 8.50917C51.0298 7.57084 49.5714 7.26235 49.5714 6.31118C49.5714 5.60422 50.3774 5.02581 51.5031 5.02581C52.4882 5.02581 54.0745 5.50139 54.6885 6.59396L57.8483 3.53477C57.0423 1.49103 54.5862 0 51.4392 0C47.5246 0 44.1346 2.55789 44.1346 6.14408C44.1346 9.26754 46.3733 10.9899 48.983 12.1211C51.0042 13.0208 53.115 13.9591 53.115 15.026C53.115 15.8744 51.9765 16.2985 50.8123 16.2985C49.0853 16.2985 47.4862 15.5273 46.6291 14.2548L43.3158 17.5196C44.3521 19.8076 47.4351 21.3115 50.8251 21.3115Z",
  fill: "#330B86"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1232 21.0287H66.5984V0.308489H61.1232V21.0287Z",
  fill: "#330B86"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M84.3034 0.308489H68.9267V5.44998H73.8774V21.0287H79.3655V5.44998H84.3034V0.308489Z",
  fill: "#330B86"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M100 5.42427V0.308489H86.6317V21.0287H100V15.8744H92.043V12.9051H98.5928V8.31636H92.043V5.42427H100Z",
  fill: "#330B86"
});

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 22,
    viewBox: "0 0 100 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.2fadcf25.svg";
export { ForwardRef as ReactComponent };